module.exports = __webpack_public_path__ + "static/media/32.08627722.png";